<template>
  <div class="page-head">
    <div class="left">
      <img :src="logo" class="logo" />
    </div>
    <div class="line"></div>
    <div class="right">
      <p class="title">{{ pageName }}</p>
      <!-- <p class="domain">www.zlgx.com</p> -->
    </div>
  </div>
</template>
<script>
// import logo from '@/assets/logo_gangxin.png'

export default {
  name: '',
  props: {
    pageName: String,
  },
  data() {
    setTimeout(() => {
      let logo =
        JSON.parse(localStorage.getItem('WEB_INFO')).init.headerLogo || '';
      this.logo = logo;
    }, 500);
    return {
      logo: '',
    };
  },
};
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
